module.exports = {
    "ApiUrl": "https://rm-api-test2-ase-dev.icarehealth.com.au/api/",
    "IdentityServerAuthority": "https://rm-test2-identity-ase-dev.icarehealth.com.au",
    "SignalRUrl": "https://rm-api-test2-ase-dev.icarehealth.com.au/signalr",
    "AutomationEnabled": true,
    "MedicareTimeZone": "Australia/Melbourne"
};
